<template>
  <FormCreate
    :errors="errors"
    :fields="fields"
    model="year"
    @submitted="create"
  >
    <div class="elr-form-row">
      <InputText
        label="Year Made"
        v-model="formData.year_made"
        fieldName="year_made"
        :errors="errors"
        :errorMessage="(errors && errors.year_made) ? errors.year_made[0] : null"
        :required=true
      />
    </div>
    <div class="elr-form-row">
      <InputTextArea
        label="Description"
        v-model="formData.description"
        fieldName="description"
        :errorMessage="(errors && errors.description) ? errors.description[0] : null"
      />
    </div>
  </FormCreate>
</template>

<script>
import { mapActions } from 'vuex';
import { validate } from '../../utils/validation';
import FormCreate from '../FormCreate/FormCreate';
import InputText from '../InputText/InputText';
import InputTextArea from '../InputTextArea/InputTextArea';

export default {
  name: 'FormYearCreate',
  data() {
    return {
      formData: {
        name: null,
        year_made: null,
        description: null
      },
      fields: [
        {
          name: 'year_made',
          label: 'Year Made',
          type: 'text',
          rules: 'required|isAlphaSpaces|isMinLength:4|isMaxLength:4',
        },
        {
          name: 'description',
          label: 'Description',
          type: 'textarea',
          // rules: 'isMaxLength:300'
        }
      ]
    };
  },
  components: {
    FormCreate,
    InputText,
    InputTextArea
  },
  computed: {
    errors() {
      return (this.$store && this.$store.state.year.errors) ? this.$store.state.year.errors[0] : {};
    }
  },
  methods: {
    ...mapActions('year', ['ADD', 'SET_ERROR', 'RESET_ERRORS']),
    validate(data) {
      const errors = validate(this.fields, data);

      if (this.hasErrors(errors)) {
        this['SET_ERROR']({ errors });
        this.$emit('error', { errors });

        return true
      }

      return false;
    },
    hasErrors(errors) {
      if (errors) {
        return !!Object.keys(errors).length;
      }

      return false;
    },
    inErrors(errors, field) {
      if (!this.hasErrors(errors)) {
        return;
      }

      const keys = Object.keys(errors);

      return keys.includes(field)
    },
    resetForm() {
      this.formData = {
        year_made: null,
        description: null
      };
    },
    create() {
      if (this.validate(this.formData)) {
        return;
      }

      this['ADD'](this.formData);
      this['RESET_ERRORS']();
      this.$emit('submitted', { data: this.formData });
    }
  }
};
</script>
